import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Store contact form submission in Firebase
export const storeContactMessage = async (contactData) => {
  try {
    const contactsRef = collection(db, 'contactSubmissions');
    const docRef = await addDoc(contactsRef, {
      ...contactData,
      status: 'new',
      createdAt: serverTimestamp(),
      read: false
    });
    return docRef.id;
  } catch (error) {
    console.error('Error storing contact message:', error);
    throw error;
  }
};

// Get all contact submissions (for admin use)
export const getContactSubmissions = async () => {
  // Implementation for admin panel
};